// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.


export class GrantedPermissions extends Array {

  has(require: string): boolean {
    const p = new RegExp(require.replace(/\*/, "[a-z]+"))
    return this.filter((permission) => p.test(permission)).length > 0
  }
}